import React from 'react';

export type PipeInventoryViewMode = 'material' | 'fitter';

type PipeInventoryViewToggleProps = {
  value: PipeInventoryViewMode;
  onChange: (mode: PipeInventoryViewMode) => void;
  /** When false, Pipe Fitter tab is hidden (e.g. user role with no fitter project access). */
  showFitterTab?: boolean;
};

/** Same segmented control pattern as Project Materials Overview | Table view. */
export const PipeInventoryViewToggle: React.FC<PipeInventoryViewToggleProps> = ({
  value,
  onChange,
  showFitterTab = true,
}) => {
  return (
    <div className="inline-flex bg-page-bg border border-[#E2E5EA] rounded-lg p-[3px]">
      <button
        type="button"
        onClick={() => onChange('material')}
        className={`px-3 py-1.5 rounded-md text-[12px] font-medium transition-all duration-150 ${
          value === 'material'
            ? 'bg-white text-blueprint-blue shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
            : 'text-heritage-grey hover:text-blueprint-blue'
        }`}
      >
        Material
      </button>
      {showFitterTab ? (
        <button
          type="button"
          onClick={() => onChange('fitter')}
          className={`px-3 py-1.5 rounded-md text-[12px] font-medium transition-all duration-150 ${
            value === 'fitter'
              ? 'bg-white text-blueprint-blue shadow-[0_1px_3px_rgba(0,0,0,0.06)]'
              : 'text-heritage-grey hover:text-blueprint-blue'
          }`}
        >
          Pipe Fitter
        </button>
      ) : null}
    </div>
  );
};
